import { LandingMetaProps } from '@anm/api/modules/hosting';
import { Config as FinalFormConfig } from 'final-form';
import omitBy from 'lodash/fp/omitBy';
import isNil from 'lodash/isNil';
import { FC } from 'react';
import { Form, FormRenderProps } from 'react-final-form';
import { TextAreaField, TextField } from '../fields';

import { ControlGroup, FormWrapper } from './Wrapper';

type HOCs = FinalFormConfig;

type LandingMetaFormProps = {
  onChange: (value: LandingMetaProps) => void;
  disabled?: boolean;
  isPending?: boolean;
};

const renderForm = ({ disabled = false, onChange: handleChange }: LandingMetaFormProps) => ({
  handleSubmit,
  values
}: FormRenderProps) => {
  const handleBlur = (values: { [key: string]: string | undefined }) => {
    const cleanedValues = omitBy(isNil)(values);

    handleChange(cleanedValues);
  };

  return (
    <FormWrapper onSubmit={handleSubmit} onBlur={() => handleBlur(values)}>
      <ControlGroup disabled={disabled}>
        <TextField
          name="heading"
          label="Headline"
          placeholder="Type your page headline here"
          inputVariant="simple-small"
          labelVariant="static-above"
        />
        <TextAreaField
          resize={false}
          name="bodyText"
          label="Body text (markdown is supported)"
          placeholder="Type your page body text here"
          labelVariant="static-above"
        />
      </ControlGroup>
    </FormWrapper>
  );
};
const LandingMetaForm: FC<HOCs & LandingMetaFormProps> = props => <Form render={renderForm(props)} {...props} />;

export default LandingMetaForm;
